import React, { Component } from 'react';

class NotFound extends Component {
  render() {
    return (
      <div>
        PAGE NOT FOUND!
      </div>
    );
  }
}

export default NotFound;
